import { Article } from "./article";
import { LocalCombinationItem } from "@coworker/apprestructured/src/shared/types/localCombinationItem";
import { Group, GroupApiResponse } from "./groups";

const unknown = "Unknown";

export function mapArticleInfoToArticle(item: LocalCombinationItem): Article {
  const hasName = !!item?.name?.trim();
  const hasDescription = !!item?.description?.trim();

  return {
    productArticleId: item?.no,
    productArticleType: item?.type || unknown,
    itemName: hasName ? item.name.trim() : unknown,
    // Unknown only if both name and description are missing
    itemType: hasDescription ? item.description.trim() : hasName ? "" : unknown,
    itemColor: hasDescription
      ? (item.description.split(",")?.[1] ?? "")
      : hasName
        ? ""
        : unknown,
    imageSmall: item?.smallImageUrl || item?.imageUrl || unknown,
    hfb: item?.hfbNo || unknown,
    articlesCountInCombination: item?.itemsCountInCombination || 0,
  } as Article;
}

export function mapGroupApiResponseToGroup(
  apiResponse: GroupApiResponse
): Group {
  return {
    id: apiResponse.id,
    name: apiResponse.name,
    description: apiResponse.description,
    parentGroupId: apiResponse.parent_group_id,
    storeId: apiResponse.store_id,
    mediaId: apiResponse.media_id,
    createdAt: apiResponse.created_at,
    updatedAt: apiResponse.updated_at,
  };
}
